import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  CcdlToastService,
  ToastRef,
  ToastType,
} from '@cpm-pr1618001/ng-design-lib';
import {
  DashboardLabelsFacade,
  HttpRequestStatus,
} from '@cpm-pr1618003/ng-initializer-lib';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { LandingPagePresenter } from '../landing-page.presenter';
import { LandingPageFacade } from '../store/facade/landing-page.facade';
import { AboutUsComponent } from './about-us.component';

@Component({
  selector: 'about-us',
  templateUrl: './about-us.container.component.html',
  styleUrl: './about-us.container.component.scss',
  imports: [CommonModule, AboutUsComponent],
  standalone: true,
})
export class AboutUsContainerComponent implements OnInit, OnDestroy {
  countries$ = this.dashboardLabelsFacade.countries$;
  contactForm!: FormGroup;
  isSubmitTriggered: boolean = false;

  private subscription = new Subscription();

  constructor(
    private landingPagePresenter: LandingPagePresenter,
    private landingPageFacade: LandingPageFacade,
    private dashboardLabelsFacade: DashboardLabelsFacade,
    private ccdlToastService: CcdlToastService,
  ) {}

  ngOnInit(): void {
    this.contactForm = this.landingPagePresenter.initializeContactForm();

    this.subscription.add(
      this.landingPageFacade.contactUsRequestStatus$
        .pipe(distinctUntilChanged())
        .subscribe((status: HttpRequestStatus) => {
          this.handleContactUsRequestStatus(status);
        }),
    );
  }

  handleContactUsRequestStatus(status: HttpRequestStatus): void {
    let title: string = 'Submission Failed';
    let message: string = 'Something went wrong. Please try again.';
    let type: ToastType = 'error';
    if (status === HttpRequestStatus.Idle) {
      this.isSubmitTriggered = false;
    } else if (status === HttpRequestStatus.Success) {
      title = 'Message Sent!';
      message =
        'Your message has been submitted. We will get back to you within 7 business days.';
      type = 'success';
      this.openToast(title, message, type);
      this.contactForm.reset();
      this.isSubmitTriggered = false;
    } else if (status === HttpRequestStatus.Failed) {
      this.openToast(title, message, type);
    }
  }

  openToast(title: string, message: string, type: ToastType): void {
    const toastRef: ToastRef = this.ccdlToastService.open({
      title: title,
      message: message,
      type: type,
      timeout: 6,
    });
    toastRef.result.finally(() => {
      this.landingPageFacade.resetContactUsRequestStatus();
    });
  }

  contactFormClicked(): void {
    this.isSubmitTriggered = true;
    if (this.contactForm.valid) {
      this.landingPageFacade.submitContactUs(
        this.landingPagePresenter.getContactFormPayload(),
      );
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
